import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {DisposeMixin} from "../../shared/mixins/dispose.mixin";
import {EmptyMixin} from "../../shared/mixins/empty.mixin";

@Injectable({
    providedIn: "root"
})
export class CofaWidgetService extends DisposeMixin(EmptyMixin) implements OnDestroy {
    public constructor(
    ) {
        super();
    }
    public searchModeObserver: BehaviorSubject<boolean> = new BehaviorSubject(true);
    public lotNumberObserver: Subject<string> = new Subject();

    public setSearchMode(): void {
        this.searchModeObserver.next(true);
    }

    public setRequestMode(): void {
        this.searchModeObserver.next(false);
    }

    public setLotNumber(lotNumber: string): void {
        this.lotNumberObserver.next(lotNumber);
    }

    public ngOnDestroy(): void {
        this.dispose();
    }
}
